import * as Yup from "yup";
export const schema = Yup.object().shape({
  paymentSettings: Yup.array().of(
    Yup.object().shape({
      publishable_key: Yup.string().required("Required"), // these constraints take precedence
      secret_key: Yup.string().required("Required"), // these constraints take precedence
    })
  ),
});
